import { StyledListItemIcon, StyledMenuItem } from "../../StyledComponents";
import { Add24Icon } from "@kaltura/ds-react-icons";
import { useState } from "react";
import { ImportChannelModalContent, ImportChannelModalContentProps } from "./modal-content/ImportChannelModalContent";
import { MenuItemProps, Modal } from "@kaltura/ds-react-components";
import { ActionItemInjectedProps } from "../../ActionItemInjectedProps";

export interface ImportChannelActionProps
    extends Omit<ImportChannelModalContentProps, "onModalClose">,
        MenuItemProps,
        ActionItemInjectedProps {
    label: string;
}

/**
 * Channel Import Channel menu action item
 */
export const ImportChannelAction = ({
    label,
    channels,
    url,
    channelId,
    errorMessage,
    onCloseMenu,
    ...menuItemProps
}: ImportChannelActionProps) => {
    const [openModal, setOpenModal] = useState(false);

    const handleCloseModal = () => {
        setOpenModal(false);
        onCloseMenu?.();
    };

    return (
        <>
            <StyledMenuItem {...menuItemProps} onClick={() => setOpenModal(true)}>
                <StyledListItemIcon>
                    <Add24Icon />
                </StyledListItemIcon>
                {label}
            </StyledMenuItem>

            <Modal open={openModal} onClose={handleCloseModal} onKeyDown={(ev) => ev.stopPropagation()}>
                <ImportChannelModalContent
                    onModalClose={handleCloseModal}
                    channels={channels}
                    url={url}
                    channelId={channelId}
                    errorMessage={errorMessage}
                />
            </Modal>
        </>
    );
};

export default ImportChannelAction;
